import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class IdentityInvitation extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true }
        };
    }

    /**
     * Create model list from api return
     */
    static list(apiList) {
        return apiList;
    }

    static getItemUrl(...args) {
        return this.listUrl(...args);
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId && !partnerId) {
            throw new ArgumentError('[Model][SeatInventory][get] organizationId or partnerId is mandatory');
        }

        if (!partnerId) {
            return `/ticket/organizations/${organizationId}/identities/partner-identity`;
        }
        return `/ticket/organizations/${organizationId}/partners/${partnerId}/identity`;
    }
}
